import { http } from "./api";
import { getPosition, getDeviceInfo } from "./deviceInfo";

/* Marks a half present for the current user, attaching GPS + device fingerprint. */
export async function markAttendance(half, extra = {}) {
  const [pos, device] = [await getPosition(), getDeviceInfo()];
  const body = { half, ...device, ...extra };
  if (pos.error) body.location_error = pos.error;
  else Object.assign(body, { lat: pos.lat, lng: pos.lng, accuracy: pos.accuracy });
  return http.post("/attendance/mark", body);
}
